export const LOAD_SATPLANTS = "LOAD_SATPLANTS";
export const LOAD_SATPLANTS_SUCCESS = "LOAD_SATPLANTS_SUCCESS";
export const LOAD_SATPLANTS_ERROR = "LOAD_SATPLANTS_ERROR";

